/** A reload or closing the tab with unsaved changes asks first (the browser's own "Leave site?"), as the editor and the
 * Sketch do: Branding, Rules, and the admin console's Plans & limits and Platform settings (live tests EX-05, LT-88,
 * C-admin). */
import { useEffect } from "react";

type Target = Pick<Window, "addEventListener" | "removeEventListener">;

/** While `dirty`, `beforeunload` is cancelled (the browser asks); returns the cleanup. */
export function guardUnload(target: Target, dirty: boolean): () => void {
  if (!dirty) return () => {};
  const warn = (e: Event) => e.preventDefault();
  target.addEventListener("beforeunload", warn);
  return () => target.removeEventListener("beforeunload", warn);
}

export function useLeaveGuard(dirty: boolean) {
  useEffect(() => guardUnload(window, dirty), [dirty]);
}

/** The same, for a page that knows `dirty` only after its early returns: render it next to the content. */
export function LeaveGuard({ dirty }: { dirty: boolean }) {
  useLeaveGuard(dirty);
  return null;
}
